"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zIndex = void 0;
// ZIndex

const zIndex = exports.zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};